module.exports = __webpack_public_path__ + "static/media/Fortis-Healthcare2.3f17c397.webp";